<template>
  <el-form ref="form" :model="form" class="box-set" label-width="120px">
    <el-card header="基础信息" shadow="naver">
      <el-form-item label="名称" prop="marketing_name" :rules="{required: true, message: '活动名称必填', trigger: 'blur'}">
        <el-col :span="20">
          <el-input v-model="form.marketing_name" :maxlength=30 placeholder="最多30个字"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="促销规则">
        <el-row :gutter="1">
          <el-col :span="7">
            <el-radio v-model="form.condition_type" label="quantity">按订单总件数</el-radio>
            <el-radio v-model="form.condition_type" label="totalfee">按订单总金额</el-radio>
          </el-col>
          <el-col :span="6">
              <span v-if="form.condition_type == 'totalfee'" v-for="(item,key) in conditionValue" :key="key">消费满 <el-input type="input" v-model="item.full" placeholder="0.00" style="width:100px" size="mini"></el-input> 元，送赠品</span>
              <span v-if="form.condition_type == 'quantity'" v-for="(item,key) in conditionValue" :key="key">消费满 <el-input type="input" v-model="item.full" placeholder="0.00" style="width:100px" size="mini"></el-input> 件，送赠品</span>
          </el-col>
        </el-row>
        <div>
          <el-button type="primary" class="el-icon-plus" @click="relGiftsClick" size="mini" round>选赠品</el-button>
          <el-table v-if="relGifts.length>0" :data="relGifts" style="line-height: normal">
            <el-table-column label="ID" prop="item_id" width="60"></el-table-column>
            <el-table-column label="名称" prop="item_name"></el-table-column>
            <el-table-column label="赠品数量" width="90">
              <template slot-scope="scope">
                <el-input v-model="scope.row.gift_num" width="90" size="mini"></el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column label="其他配置" width="200">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.without_return">退货无需退回赠品</el-checkbox>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" width="50">
              <template slot-scope="scope">
                <i class="iconfont icon-trash-alt" @click="deleteGiftRow(scope.$index)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="规则描述">
        <el-col :span="20">
          <el-input type="textarea" :rows="3" v-model="form.marketing_desc" placeholder="规则描述"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="可参与次数">
        <el-col :span="20">
          <el-input type="input" v-model="form.join_limit" placeholder="整数数字"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="适用会员">
        <el-checkbox-group v-model="validGrade">
          <el-checkbox v-for="grade in memberGrade" :label="grade.grade_id" :key="grade.grade_id">{{grade.grade_name}}</el-checkbox>
          <el-checkbox v-for="vipdata in vipGrade" :label="vipdata.lv_type" :key="vipdata.lv_type">付费{{vipdata.grade_name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="适用平台">
        <el-radio-group v-model="form.used_platform">
          <el-radio :label="0">全场可用</el-radio>
          <!-- <el-radio :label="1">只用于pc端</el-radio>
          <el-radio :label="2">只用于小程序端</el-radio>
          <el-radio :label="3">只用于h5端</el-radio> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有效期">
        <el-col :span="20">
          <el-date-picker
            v-model="activity_date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="生效时间"
            end-placeholder="过期时间"
            format="yyyy/MM/dd HH:mm:ss"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-col>
      </el-form-item>
      <GoodsSelect :items-visible="giftVisible" :get-status="setGiftStatus" :rel-items-ids="relGifts" is-spec :item-type="form.item_type" @chooseStore="chooseGiftsAction" @closeStoreDialog="closeGiftsDialogAction"></GoodsSelect>
      <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-data-ids="relStores" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect>
    </el-card>
    <el-card header="绑定商品" shadow="naver">
      <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
    </el-card>
    <el-card header="绑定店铺" shadow="naver" v-if="system_mode !== 'platform' && !is_distributor">
      <el-button type="primary" @click="relStoresClick">选店铺</el-button>
      <el-table v-if="relStores.length > 0" :data="relStores" style="line-height: normal">
        <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <i class="iconfont icon-trash-alt" @click="deleteStoreRow(scope.$index, form.items)"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="content-center">
      <el-button type="primary" v-if="hasSaveButton"  @click="submitActivityAction()">保存</el-button>
      <el-button @click.native="handleCancel">返回</el-button>
    </div>
  </el-form>
</template>

<script>
import { addMarketingActivity, updateMarketingActivity, getMarketingActivityInfo } from '../../../../api/promotions'
import { getGradeList } from '../../../../api/membercard'
import { listVipGrade } from '../../../../api/cardticket'
import { getDefaultCurrency } from '../../../../api/company'
import StoreSelect from '@/components/storeListSelect'
import GoodsSelect from '@/components/goodsSelect'
import SkuSelector from '@/components/function/skuSelector'
import store from '@/store'
export default {
  inject: ['refresh'],
  components:{
    GoodsSelect,
    StoreSelect,
    SkuSelector
  },
  data () {
    return {
      is_distributor: false,
      cursymbol: '￥',
      storeVisible: false,
      relItems: [],
      relStores: [],
      setStatus: false,
      form: {
        marketing_id: '',
        marketing_type: 'full_gift',
        marketing_name: '',
        marketing_desc: '',
        start_time: '',
        end_time: '',
        used_platform: 0,
        use_bound: 0,
        use_shop: 0,
        shop_ids: [],
        item_ids: [],
        item_type: 'normal',
        valid_grade: [],
        condition_type: 'totalfee',
        condition_value: [],
        join_limit: 0,
        promotion_tag: '满赠',
        canjoin_repeat: false,
      },
      vipGrade: [],
      memberGrade: [],
      conditionValue: [
        {full:''},
      ],
      validGrade: [],
      activity_date: '',
      selectItemType: 'normal',
      itemVisible: false,
      setItemStatus: false,
      imgDialog: false,
      isGetImage: false,
      isIndeterminate: true,
      checkAll: false,
      relGifts: [],
      setGiftStatus: false,
      giftVisible: false,
      hasSaveButton: true
    }
  },
  watch: {
    'form.item_ids': {
      handler: function(val) {
        if (val) {
          this.form.use_bound = val.length > 0 ? 1 : 0
        }
      }
    },
    'form.shop_ids': {
      handler: function(val) {
        if (val) {
          this.form.use_shop = val.length > 0 ? 1 : 0
        }
      }
    }
  },
  methods:{
    getItems(data) {
      let ids = []
      data.forEach(item => {
        ids.push(item.itemId)
      })
      this.form.item_ids = ids
    },
    addRules () {
      this.conditionValue.push({full:''})
    },
    delRules(index){
      this.conditionValue.splice(index,1)
    },
    relStoresClick(){
      this.storeVisible = true
      this.setStatus = true
    },
    chooseStoreAction (data) {
      this.storeVisible = false
      this.form.shop_ids = []
      if (data === null || data.length <= 0) return
      this.relStores = data
    },
    closeStoreDialogAction () {
      this.storeVisible = false
    },
    deleteStoreRow (index, ) {
      this.setStatus = false
      this.relStores.splice(index,1)
    },
    submitActivityAction () {
      const that = this
      let thisform = JSON.stringify(this.form)
      thisform = JSON.parse(thisform)
      if (this.activity_date.length > 0) {
        thisform.start_time = this.activity_date[0]/1000
        thisform.end_time = this.activity_date[1]/1000
      }

      if (this.conditionValue.length > 0) {
        thisform.condition_value = JSON.stringify(this.conditionValue)
      }
      if (this.validGrade.length > 0) {
        thisform.valid_grade = this.validGrade
      }

      this.form.shop_ids = []
      if (this.relStores && this.relStores.length > 0) {
        this.relStores.forEach( item => {
          this.form.shop_ids.push(item.distributor_id)
        })
      }

      if (this.relGifts.length <= 0) {
        this.$message.error('请选择赠品!')
        return false
      }
      let giftData = []
      this.relGifts.forEach( item => {
        let itemdata = {
          item_id: item.item_id,
          item_name: item.item_name,
          item_type: item.item_type,
          price: 0,
          without_return: item.without_return,
          gift_num: item.gift_num,
          pics: item.pics,
          filter_ful: this.conditionValue[0].full
        }
        giftData.push(itemdata)
      })
      thisform.gifts = JSON.stringify(giftData)

      if (thisform.item_ids && thisform.item_ids.length <= 0) {
        this.$message.error('参加活动的商品必填!')
        return false
      }
      this.use_bound = 1
      thisform.item_ids = JSON.stringify(thisform.item_ids)
      thisform.shop_ids = JSON.stringify(this.form.shop_ids)
      if (this.form.marketing_id) {
        updateMarketingActivity(thisform).then(res => {
          if(res.data.data.marketing_id){
            this.loading = false
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      } else {
        addMarketingActivity(thisform).then(res => {
          if(res.data.data.marketing_id){
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      }
    },
    getActivityDetail(id) {
      getMarketingActivityInfo({marketing_id:id}).then(res => {
        let response = res.data.data
        let data = {
          marketing_type: 'full_gift',
          promotion_tag: '满赠',
          marketing_id: response.marketing_id,
          marketing_name: response.marketing_name,
          marketing_desc: response.marketing_desc,
          start_time: response.start_time,
          end_time: response.end_time,
          used_platform: response.used_platform,
          use_bound: response.use_bound,
          use_shop: response.use_shop,
          valid_grade: response.valid_grade,
          condition_type: response.condition_type,
          condition_value: response.condition_value,
          join_limit: response.join_limit,
          item_type: response.item_type,
          canjoin_repeat: response.canjoin_repeat,
        }
        Object.assign(this.form, data)
        this.conditionValue = response.condition_value
        this.validGrade = response.valid_grade
        this.activity_date = [response.start_time*1000, response.end_time*1000]
        this.relItems = response.itemTreeLists || []
        this.relStores = response.storeLists || []
        this.relGifts = response.gifts || []
      })
    },
    handleCancel: function () {
      this.$router.back(-1)
    },
    relGiftsClick () {
      this.giftVisible = true
      this.setGiftStatus = true
    },
    chooseGiftsAction (data) {
      this.giftVisible = false
      let list = JSON.parse(JSON.stringify(data))
      if (data === null || data.length <= 0) return
      if (data.length > 4) {
        this.$message.error('赠品最多4件商品!')
        return false
      }
      list.forEach((item, index) => {
        item.gift_num = 1
        item.without_return = false
      })
      this.relGifts = list
    },
    closeGiftsDialogAction () {
      this.giftVisible = false
    },
    deleteGiftRow: function (index) {
      this.setGiftStatus = false
      this.relGifts.splice(index, 1)
    },
  },
  mounted () {
    if (store.getters.login_type === 'distributor') {
      this.is_distributor = true
    }
    if (this.$route.params.marketing_id) {
      this.getActivityDetail(this.$route.params.marketing_id)
    }
    if (this.$route.query.isnodata) {
      this.hasSaveButton = false
    }
    listVipGrade().then(response => {
      if(response != undefined && response.data.data && response.data.data.length >0) {
        this.vipGrade = response.data.data
      }
    })

    getGradeList().then(response => {
      if(response != undefined && response.data.data && response.data.data.length >0) {
        var result = response.data.data
        if(result) {
          this.memberGrade = result
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?b96528e4